import { createAction, handleActions } from 'redux-actions';
import produce from 'immer';

const OPEN_TOOLTIP = 'tooltip/OPEN_TOOLTIP';
const CLOSE_TOOLTIP = 'tooltip/CLOSE_TOOLTIP';

export const openTooltip = createAction(OPEN_TOOLTIP);
export const closeTooltip = createAction(CLOSE_TOOLTIP);

const initialState = {
	show: false,
	style: {},
	offset: null,
	content: '',
	className: '',
};

export default handleActions(
	{
		[OPEN_TOOLTIP]: (state, { payload }) =>
			produce(state, (draft) => {
				const { style, offset, content, className } = payload;
				draft.show = true;
				draft.style = style || {};
				draft.offset = offset;
				draft.content = content;
				draft.className = className;
			}),
		[CLOSE_TOOLTIP]: (state) =>
			produce(state, (draft) => {
				draft.show = false;
				draft.style = {};
				draft.offset = null;
				draft.content = '';
				draft.className = '';
			}),
	},
	initialState,
);
